import { configure } from 'instantsearch.js/es/widgets';
import { defaultCard } from '../../partials/algolia-cards/default-card';
import { SearchBox, Stats, Hits, CurrentRefinements, Pagination } from '../../src/js/algolia/widgets';
import StuurluiAlgolia from '../../src/js/algolia';

const APP_ID = strl_vars.algolia_app_id;
const API_KEY = strl_vars.algolia_api_key;

function hitsEmptyTemplate(results) {
	if (results.query === '') {
		return null;
	}
	return `<p class="text-h3 font-semibold" data-no-results>
				${strl_vars.no_hits}
			</p>`;
}

function hitsItemTemplate(hit, { html, components }) {
	return defaultCard(hit, html, components);
}

const algolia = new StuurluiAlgolia(APP_ID, API_KEY, search_vars['index_name'], [], {
	minQueryLength: 3,
});

algolia.addWidgets([
	configure({
		hitsPerPage: 8,
	}),
	SearchBox(),
	Pagination('#search-pagination'),
	Stats(),
	Hits(
		{
			empty: hitsEmptyTemplate,
			item: hitsItemTemplate,
		},
		'#hits',
		{
			list: 'list-none grid grid-cols-1 gap-auto',
		}
	),
]);

algolia.start();
